import styled from 'styled-components'
import { v4 as uuid4 } from 'uuid'
import { useEffect, useState } from 'react'

import { generateTagId } from '@/utils/test-automation'

interface Props {
  text: {
    title: string
    buttonLabel: string
    description: string
  }
  blurImageSrc: string
  children: React.ReactNode
  onClickButton: () => void
}

const LoginRequiredContentArea = (props: Props): JSX.Element => {
  const [contentId, setContentId] = useState('')

  useEffect(() => {
    setContentId(`content-${uuid4().split('-')[0]}`)
  }, [])

  return (
    <StyledDoctorBlurredArea>
      <StyledListDoctorBlurImg src={props.blurImageSrc} alt="blur image" />
      <StyledLoginNotice>
        {props.children}
        <StyledCuriousAboutContentOfDoctor>{props.text.title}</StyledCuriousAboutContentOfDoctor>
        <StyledLoginAndWatchButton
          id={generateTagId('all', 'paywall', 'btn', 'login', contentId)}
          onClick={(e) => {
            e.stopPropagation()
            props.onClickButton()
          }}
        >
          {props.text.buttonLabel}
        </StyledLoginAndWatchButton>
        <StyledShouldLoginToWatch>{props.text.description}</StyledShouldLoginToWatch>
      </StyledLoginNotice>
    </StyledDoctorBlurredArea>
  )
}

export default LoginRequiredContentArea

const StyledDoctorBlurredArea = styled.div`
  position: relative;
  margin-top: 10px;
  margin-bottom: -11px;
`

const StyledListDoctorBlurImg = styled.img`
  margin-left: -26px;
`

const StyledLoginNotice = styled.div`
  position: absolute;
  top: 23px;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

const StyledCuriousAboutContentOfDoctor = styled.p`
  ${({ theme }) => theme.typography.title3};
`

const StyledLoginAndWatchButton = styled.button`
  width: 100%;
  height: 40px;
  ${({ theme }) => theme.typography.title4};
  color: ${({ theme }) => theme.colors.orange};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.orange};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  cursor: pointer;
`

const StyledShouldLoginToWatch = styled.p`
  margin-top: 16px;
  ${({ theme }) => theme.typography.description2};
  color: ${({ theme }) => theme.colors.gray800};
`
